export const AD_FIELDS = [
  'bodyType',
  'builtYear',
  'co2Value',
  'contact',
  'exclusive',
  'firstRegistrationYear',
  'fuelConsumption',
  'fuelType',
  'gearType',
  'has360Images',
  'horsePower',
  'id',
  'kw',
  'location',
  'manufacturer',
  'mileage',
  'model',
  'monthlyPayment',
  'offerPrice',
  'overviewImage',
  'pathTitle',
  'published',
  'firstPublishedAt',
  'registration',
  'sellerId',
  'sellerLogo',
  'sellerName',
  'sellerType',
  'subtitle',
  'subType',
  'subTypeExtra',
  'title',
  'tuvNumber',
  'vatRate',
];
